import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { Container, Section, SectionTitle } from 'chaoskit/src/components'
import useInterval from 'react-use/lib/useInterval'

import Data from '~components/Data'
import { companies } from '~helpers/downtime-companies'
import Image from '~components/Image'
import { stickyIt } from '~styles/utility'
import { formatPrice } from '~helpers/utility'
import Clock from '~partials/ecommerce-cost-of-downtime/Clock'

const DowntimeList = () => {
  const theme = useTheme()

  const [delay, setDelay] = useState(1000)
  const [time, setTime] = useState(0)

  const adjustClock = () => {
    const nextTime = time + 1

    setTime(nextTime)
  }

  useInterval(() => {
    adjustClock()
  }, delay)

  useEffect(() => {
    // Pause after 30 minutes
    if (time >= 1800) {
      setDelay(null)
    }
  }, [time])

  return (
    <div css={{ display: 'grid', gap: theme.space.large }}>
      {companies.slice(0, 5).map((company) => (
        <div
          key={company.name}
          css={{
            background: theme.color.light.base,
            borderRadius: theme.borderRadius.base,
            boxShadow: theme.boxShadow.large,
            padding: theme.space.base,
            display: 'grid',
            gap: theme.space.base,
            textAlign: 'center',

            [theme.mq.medium]: {
              textAlign: 'left',
              alignItems: 'center',
              gap: theme.space.large,
              gridTemplateColumns: 'auto 1fr',
              padding: theme.space.large,
            },
          }}
        >
          <div
            css={{
              width: 120,
              margin: '0 auto',

              [theme.mq.medium]: {
                textAlign: 'center',
                margin: 0,
              },
            }}
          >
            <Image
              css={{
                maxHeight: theme.height.large,
              }}
              alt={company.name}
              src={company.full}
            />
          </div>
          <div
            css={{
              display: 'grid',
              gap: theme.space.small,
              fontWeight: theme.fontWeight.bold,
            }}
          >
            <div css={{ ...theme.headingPreset.h3 }}>
              {formatPrice(company.revenue.second * time)}
            </div>
            <div
              css={{
                letterSpacing: theme.letterSpacing.extended,
                color: theme.fontColor.muted,
                textTransform: 'uppercase',
                fontSize: theme.fontSize.xsmall,
              }}
            >
              Revenue loss this session
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

const CostOfDownTime = ({ heading, content }) => {
  const theme = useTheme()

  return (
    <Section css={{ background: theme.brand.darkViolet }}>
      <Container>
        <div
          css={{
            display: 'grid',
            gap: theme.space.large,

            [theme.mq.medium]: {
              gridTemplateColumns: '1fr 450px',
              gap: theme.space.xlarge,
            },
          }}
        >
          <div className={theme.settings.classes.contrast}>
            <div css={{ [theme.mq.medium]: [stickyIt(theme)] }}>
              <SectionTitle
                as="h2"
                align={{ medium: 'left' }}
                title={<Data>{heading}</Data>}
                sub={<Data>{content}</Data>}
              />
              <Clock css={{ margin: 0 }} />
            </div>
          </div>
          <div>
            <DowntimeList />
          </div>
        </div>
      </Container>
    </Section>
  )
}

CostOfDownTime.propTypes = {
  heading: PropTypes.string.isRequired,
  content: PropTypes.string,
}

export default CostOfDownTime
